// 基于http.js 二次封装，为了更加方便使用

import http from '../utils/http';

function request(type, url, params, exposed = false) {
  return new Promise((resolve, reject) => {
    http[type](url, params).then(data => {
      resolve(beautyData(data));
    }).catch(message => {
      if (exposed) {
        reject(message);
        return;
      }

      reject(beautyReject(message));
    });
  });
}

const get = (url, params, exposed = false) => {
  return request('get', url, {
    params: {
      ...params,
    },
  }, exposed);
};

const post = (url, params, exposed = false) => {
  return request('post', url, params, exposed);
};

const getSign = (url, params, exposed = false) => {
  return request('get', url, {
    params: {
      ...params,
      _sign: true,
    },
  }, exposed);
};

const postSign = (url, params, exposed = false) => {
  return request('post', url, {
    ...params,
    _sign: true,
  }, exposed);
};

function beautyData(data) {
  if (data == null) {
    return '';
  }

  if (typeof data == 'undefined') {
    return '';
  }

  if (typeof data == 'object' && Array.isArray(data) == false) {
    const _data = beautifulDict(data);
    return _data;
  }

  return data;
}

function beautifulDict(data) {
  Object.keys(data).map((key) => {
    if (data[key] == null) {
      data[key] = '';
    }
  });

  return data;
}

function beautyReject(data) {
  if (typeof data == 'object') {
    return data.message || data.msgContent || '网络错误';
  }

  return data;
}

export default {
  get,
  post,
  getSign,
  postSign,
};
